import React from "react";
import { Container } from "../container";

type Item = {
  url?: string | null;
  article?: { title?: string | null; slug?: string | null } | null;
  artist?: { name?: string | null; url?: string | null } | null;
  artwork?: { title?: string | null; url?: string | null } | null;
  description?: string | null;
  id?: string | null;
  title?: string | null;
  type?: string | null;
};

export const LinksList: React.FC<{
  items: (null | Item)[];
}> = ({ items, ...props }) => {
  const half = Math.ceil(items.length / 2);
  const firstHalf = items.slice(0, half);
  const secondHalf = items.slice(half);
  const getTarget = (item: Item) => (item.type === "external" ? "_blank" : "");
  const getListItem = (item: Item | null) => {
    if (!item) return null;
    return (
      <div className="mb-3" key={`links-list-${item.id}`} {...props}>
        <a
          key={item.id}
          className="text-m"
          href={item.url || "#"}
          target={getTarget(item)}
        >
          <div className="leading-tight underline underline-offset-2">
            {item.title}
          </div>
          <div className="font-sans text-beige">{item.description}</div>
        </a>
      </div>
    );
  };
  return (
    <div {...props}>
      <Container className="my-10 grid grid-cols-4 gap-16">
        <div className="hidden lg:col-span-1 lg:flex"></div>
        <div className="col-span-4 grid max-h-[32rem] grid-cols-2 gap-16 overflow-y-auto border-b border-t border-beige py-7 lg:col-span-2 lg:space-x-6">
          <div className="col-span-4 lg:col-span-1">
            {firstHalf.map(getListItem)}
          </div>
          <div className="col-span-4 lg:col-span-1">
            {secondHalf.map(getListItem)}
          </div>
        </div>
      </Container>
    </div>
  );
};
